var loadIndustriesSlider = function loadIndustriesSlider() {
  var slider = document.querySelector(".home-industries__wrapper .splide");
  if (slider) {
    var splide = new Splide(slider, {
      arrows: false,
      pagination: false,
      type: "slide",
      perPage: 3.6,
      gap: 32,
      focus: 0,
      drag: false,
      breakpoints: {
        780: {
          perPage: 2.2,
          gap: 16
        },
        600: {
          perPage: 1.5
        }
      }
    });
    splide.mount();

    // === Custom mouse drag logic ===
    var track = slider.querySelector(".splide__list");
    var isDown = false;
    var startX;
    var scrollLeft;
    track.addEventListener("mousedown", function (e) {
      isDown = true;
      track.classList.add("dragging");
      startX = e.pageX - track.offsetLeft;
      scrollLeft = track.scrollLeft;
    });
    track.addEventListener("mouseleave", function () {
      isDown = false;
      track.classList.remove("dragging");
    });
    track.addEventListener("mouseup", function () {
      isDown = false;
      track.classList.remove("dragging");
    });
    track.addEventListener("mousemove", function (e) {
      if (!isDown) return;
      e.preventDefault();
      var x = e.pageX - track.offsetLeft;
      var walk = (x - startX) * 1.5; // adjust speed if needed

      var move = scrollLeft - walk;
      track.scrollLeft = move;
    });
  }
};
var loadTrustedBySlider = function loadTrustedBySlider() {
  var slider = document.querySelector(".home-trusted-by__wrapper .splide");
  if (slider) {
    var splide = new Splide(slider, {
      arrows: false,
      pagination: false,
      type: "slide",
      perPage: 4.3,
      gap: 23,
      focus: 0,
      breakpoints: {
        1350: {
          perPage: 3.4,
          gap: 23
        },
        1100: {
          perPage: 2.5,
          gap: 23
        },
        989: {
          perPage: 4.2,
          gap: 16
        },
        800: {
          perPage: 3.4,
          gap: 16
        },
        700: {
          perPage: 2.5,
          gap: 16
        },
        600: {
          perPage: 1.6
        }
      }
    });
    var bar = document.querySelector(".home-trusted-by__wrapper .splide-progress-bar");
    splide.on("mounted move", function () {
      var end = splide.Components.Controller.getEnd() + 1;
      var rate = Math.min((splide.index + 1) / end, 1);
      bar.style.width = String(100 * rate) + "%";
    });
    splide.mount();
  }
};
var loadTestimonialsSlider = function loadTestimonialsSlider() {
  var slider = document.querySelector(".home-testimonials__wrapper .splide");
  if (slider) {
    var splide = new Splide(slider, {
      arrows: true,
      pagination: false,
      type: "slide",
      perPage: 1
    });
    splide.mount();
  }
};
loadTestimonialsSlider();
loadTrustedBySlider();
loadIndustriesSlider();